/**
 * 功能权限模块
 * @module feature-permission-module
 */

import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    FeaturePermissionRegistry,
    FeaturePermissionStrategy,
} from '@telecom/shared/domain/permission';
import { FeaturePermissionRegistryImpl } from '@telecom/shared/domain/permission/impls/feature-permission-registry';

// 导入各个业务模块的权限策略
import { SpecificationCnGenerationStrategy, SpecificationEuGenerationStrategy, SpecificationGenerationStrategy, SpecificationUsGenerationStrategy } from '@/domains/specification/services/specification-generation-strategy';
import { SpecificationUploadAttachmentStrategy } from '@/domains/specification/services/specification-upload-attachment-strategy';
import { ClaimTreeNodeStrategy } from '@/domains/novelty-check-report/services/claim-tree-node-strategy';
import { NoveltyCheckStrategy } from '@/domains/novelty-check-report/services/novelty-check-strategy';
import { FtoSearchStrategy } from '@/domains/fto-pro/services/fto-search-strategy';

export const featurePermissionModule = new ContainerModule((bind) => {
    // 绑定注册表（单例）
    bind(FeaturePermissionRegistryImpl).to(FeaturePermissionRegistryImpl).inSingletonScope();

    // 绑定各个模块的权限策略到 FeaturePermissionStrategy
    // Registry 会通过 multiInject 自动收集所有策略
    bind(FeaturePermissionStrategy).to(SpecificationGenerationStrategy);
    bind(FeaturePermissionStrategy).to(SpecificationEuGenerationStrategy);
    bind(FeaturePermissionStrategy).to(SpecificationUsGenerationStrategy);
    bind(FeaturePermissionStrategy).to(SpecificationCnGenerationStrategy);
    bind(FeaturePermissionStrategy).to(NoveltyCheckStrategy);
    bind(FeaturePermissionStrategy).to(FtoSearchStrategy);

    bind(FeaturePermissionStrategy).to(SpecificationUploadAttachmentStrategy);
    bind(FeaturePermissionStrategy).to(ClaimTreeNodeStrategy);
    // 添加更多策略只需要在这里继续 bind 即可
    bind(FeaturePermissionRegistry).to(FeaturePermissionRegistryImpl);
});
